
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import PathSidebar from '@/components/process/JourneyMap/components/PathSidebar.vue';
import NeedToApplyLeaveToCrossAppeal from "@/components/process/JourneyMap/components/RspToAppeal/components/NeedToApplyLeaveToCrossAppeal.vue";

import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

@Component({
    components:{
        ExpandIcon,
        PathSidebar,
        NeedToApplyLeaveToCrossAppeal
    }
})
export default class NoticeOfCrossAppealRspToAppealPg extends Vue {

    @form3State.Action
    public UpdateCurrentNoticeOfCrossAppealId!: (newCurrentNoticeOfCrossAppealId: string) => void

    
    showNoaInfo = true;
    showBringCrossAppealInfo = false;
    showNeedCrossAppealInfo = false;
    showAddDocsInfo = false;
    showAppealRecordInfo = false;
    updated=0;
    pathTypes = ["info", "share", "share"];
    pathHeights = ['19rem', '0', '0'];  

    public startNoticeOfCrossAppeal(){
        this.UpdateCurrentNoticeOfCrossAppealId(null);
        this.$router.push({name: "checklist-form3" })
    }

    public showNoa(show: boolean){
        if (show) {
            this.showNoaInfo = true;
            this.$emit('adjustHeights', 0, "5rem");
        } else {
            this.showNoaInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }        
    }

    public showBringCrossAppeal(show: boolean){
        if (show) {
            this.showBringCrossAppealInfo = true;
            this.$emit('adjustHeights', 1, "15rem")
        } else {
            this.showBringCrossAppealInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showNeedCrossAppeal(show: boolean){
        if (show) {
            this.pathHeights = ['19rem', '0', '0'];
            this.showNeedCrossAppealInfo = true;              
            this.$emit('adjustHeights', 2, "35rem")
        } else {
            this.showNeedCrossAppealInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showAddDocs(show: boolean){
        if (show) {
            this.showAddDocsInfo = true;
            this.$emit('adjustHeights', 3, "5rem")
        } else {
            this.showAddDocsInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public showAppealRecord(show: boolean){
        if (show) {
            this.showAppealRecordInfo = true;
            this.$emit('adjustHeights', 4, "3rem")
        } else {
            this.showAppealRecordInfo = false;
            this.$emit('adjustHeights', 4, "0");
        }
    }

    public showFactumSection(){
        
        this.$emit('showFactums');
    }

    public adjustHeights(index: number, pathHeight: string){       
        this.updated++;
        this.pathHeights[index] = pathHeight;
        let total = 0;
        for (const sectionHeight of this.pathHeights){
            const heightValue = Number(sectionHeight.replace("rem", ""));
            total = total + heightValue;            
        }
        total = total + 16; 
        this.$emit('adjustHeights', 2, total + "rem");
        
    }
}
